import React from "react";
import PropTypes from "prop-types";
import { ImageLoader } from "@qgiv/core-react";
import "./EventProfileImage.scss";

const EventProfileImage = ({ avatar = "", eventHomeUrl }) => (
    <div className="event-profile-image">
        <a
            className="event-profile-image__link"
            href={eventHomeUrl}
            target="_blank"
            rel="noreferrer"
        >
            <div className="event-profile-image__container">
                <ImageLoader
                    className="event-profile-image__image"
                    src={avatar}
                    alt="Event Profile Image"
                />
            </div>
        </a>
    </div>
);

EventProfileImage.propTypes = {
    avatar: PropTypes.string.isRequired,
    eventHomeUrl: PropTypes.string.isRequired,
};

export default EventProfileImage;
